export interface MenuFilterState {
  foodType?: ("veg" | "egg" | "non-veg")[];
  sortBy: "price-low-high" | "price-high-low" | "rating-high-low" | null;
  rating: number | null;
  cuisine?: [];
}

export const MenuInitialFilterState: MenuFilterState = {
  foodType: [],
  sortBy: null,
  rating: null,
};
